import { useAuthService } from '@/modules/auth/auth.service';

export async function fetchAuthDataMiddleware(to, from, next) {
  // Skip middleware for public routes like login
  if (!to.meta.requiresAuth || to.name === 'login' || to.meta.authArea === 'sales-crm') {
    return next();
  }

  const { getUserPermissions } = useAuthService();

  await getUserPermissions();

  next();
}
